const SLACK_WEBHOOK_URL =
  "https://hooks.slack.com/services/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";

const sendMessageToSlack = async (payload: {
  type: string;
  blocks: {
    type: string;
    text: {
      type: string;
      text: string;
    };
  }[];
  username: string;
  icon_emoji: string;
  channel: string;
}) => {
  await fetch(SLACK_WEBHOOK_URL, {
    method: "POST",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
    body: JSON.stringify(payload),
  });
};

export const sendAnalysisSketchSubmittedMessageToSlack = async ({
  clientName,
  branchName,
  userEmail,
  userName,
  url,
}: {
  clientName: string;
  branchName: string;
  userEmail: string;
  userName: string;
  url: string;
}) => {
  const payload = {
    type: "home",
    blocks: [
      {
        type: "section",
        text: {
          type: "mrkdwn",
          text: "<!subteam^S03NMBSNU90>",
        },
      },
      {
        type: "section",
        text: {
          type: "plain_text",
          text: "고객이 분석 스케치를 제출했습니다.",
        },
      },
      {
        type: "section",
        text: {
          type: "mrkdwn",
          text: `*클라이언트* : ${clientName}`,
        },
      },
      {
        type: "section",
        text: {
          type: "mrkdwn",
          text: `*지점* : ${branchName}`,
        },
      },
      {
        type: "section",
        text: {
          type: "mrkdwn",
          text: `*유저* : ${userName}`,
        },
      },
      {
        type: "section",
        text: {
          type: "mrkdwn",
          text: `*이메일* : ${userEmail}`,
        },
      },
      {
        type: "section",
        text: {
          type: "mrkdwn",
          text: `*링크* : ${url}`,
        },
      },
    ].filter(Boolean),
    username: "mST",
    icon_emoji: ":toolbox:",
    channel: "C01Q9NU2N9Y",
  };

  await sendMessageToSlack(payload);
};
